import React, { Component } from 'react';
import PageTitle from '../components/PageTitle';
import Event from '../components/Event';
import Toolbar from '../components/Toolbar';
import EventEditor from '../components/EventEditor';
import OnPageLoaded from '../utils/onpageloaded';
import srvEvents from '../services/srv-events';
import OPERATION from '../utils/constants';
import {EventInstance} from '../models';
//import WOW from 'wowjs';

import '../css/concerts.css'

class Concerts extends Component {
    constructor(props) {
        super(props);
        this.state = { concerts: [], currentop: OPERATION.LIST, selectedEvent: EventInstance() };
        this.setAddMode = this.setAddMode.bind(this);
    }

    setAddMode (){
        this.setState({currentop: OPERATION.ADD});
    }

    componentDidMount() {
        document.title = "Gruppo folk Damatrà - Prossimi Concerti";
        const description = "Il calendario completo dei nostri prossimi concerti bal folk. Rimani sempre aggiornato e vieni a ballare con noi le danze folk più coinvolgenti.";
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        if (window.location.hash === '')
            OnPageLoaded(true, true);
        else
            OnPageLoaded(true, false);

        srvEvents.getNextEvent().then(data => {
            this.setState({ concerts: data });
        }).catch(this.handleError);
    }

    render() {
        return (
            <div>
                <PageTitle title="Concerti" bgimgurl="/img/titlebg/concerti.jpg"></PageTitle>
                <div className="container">
                    {/*
                    <Toolbar addFunction={this.setAddMode}></Toolbar>
                    */}
                    {
                        this.state.concerts.length > 0 && this.state.currentop === OPERATION.LIST &&
                        this.state.concerts.map(concert => <Event key={concert.id} event={concert}></Event>)
                    }
                    {
                        this.state.currentop === OPERATION.ADD &&
                        <EventEditor event={this.state.selectedEvent}></EventEditor>
                    }
                </div>
            </div>
        );
    }
}

export default Concerts;


// WEBPACK FOOTER //
// ./src/pages/Concerts.js